<style scoped>
.breadcrumb-item a {
  color: rgb(0 147 221) !important;
}
.breadcrumb-item {
  font-size: 1rem;
  font-weight: 600;
}
.breadcrumb {
  display: flex;
  box-shadow: none;
  border: none;
}
</style>
<template>
  <b-container
    fluid
    class="main-wrapper mt-4"
    style="
      font-family: 'Manrope', sans-serif !important;
      font-size: 16px !important;
    "
  >
    <b-row class="ml-5 mr-5 mt-5 mb-0">
      <b-col class="ml-5 mr-5">
        <b-breadcrumb
          :items="breadcrumbs"
          class="breadcrumbs"
        ></b-breadcrumb></b-col
    ></b-row>
    <b-row class="ml-5 mr-5 mt-5 pb-5">
      <b-col class="ml-5 mr-5">
        <tabel-dinamis-title v-once>
          {{ tableDinamisVersionNumber }}
        </tabel-dinamis-title>

        <main-progress-stepper
          :isStep2.sync="isStep2"
          :disabledStep2="disabledStep2"
          :disabledStep1="disabledStep1"
          :isEditSelectedData="isEditSelectedData"
          :setIsProcessingNow="setIsProcessingNow"
          :updateTempDataCart="updateTempDataCart"
        />

        <b-card class="mt-5">
          <selection-step
            v-show="!isStep2"
            :setIsStep2="setIsStep2"
            :checkDisabledStep2="checkDisabledStep2"
            :setIsProcessingNow="setIsProcessingNow"
            :isEditSelectedData.sync="isEditSelectedData"
            :refreshKeySelectedDataList="refreshKeySelectedDataList"
            :updateRefreshKeySelectedDataList="updateRefreshKeySelectedDataList"
            :updateTempDataCart="updateTempDataCart"
            :projectName="projectName"
          />

          <visualization-step
            v-show="isStep2"
            :setIsStep2="setIsStep2"
            :isProcessingNow="isProcessingNow"
            :isStep2="isStep2"
            :setDisabledStep1="setDisabledStep1"
            :refreshKeySelectedDataList="refreshKeySelectedDataList"
            :tempDataCart="tempDataCart"
          />
        </b-card> </b-col
    ></b-row>
  </b-container>
</template>

<!-- javascript section-->
<script>
//import js modules section
import Title from "./Index/Title.vue";
import MainProgressStepper from "./Index/MainProgressStepper.vue";
import SelectionStep from "./Index/SelectionStep.vue";
import VisualizationStep from "./Index/VisualizationStep.vue";
import utils from "../../../utils/TabelDinamisUtils.js";
import store from "../../../store/TabelDinamisStoreV3.js";

//local registration for output component
export default {
  name: "Index",
  data() {
    return {
      tableDinamisVersionNumber: "3.4.1",
      isStep2: false,
      disabledStep2: true,
      disabledStep1: false,
      isProcessingNow: false,
      isEditSelectedData: false,
      refreshKeySelectedDataList: 0,
      tempDataCart: null,
    };
  },
  props: {
    projectName: {
      type: String,
      required: false,
    },
    tabelDinamisBeranda: {
      type: String,
      required: true,
    },
    tabelDinamisProjectCode: {
      type: String,
      required: true,
    },
  },
  created() {},
  destroyed() {},
  mounted: function () {
    this.scrollToUpperMost();
    this.checkDisabledStep2();
    this.setIsProcessingNow(false);
  },
  computed: {
    breadcrumbs: function () {
      let breadcrumbs = [
        {
          text: "Beranda",
          to: {
            name: this.tabelDinamisBeranda,
          },
        },
        {
          text: "Tabel Dinamis",
          active: true,
        },
      ];

      return breadcrumbs;
    },
  },
  watch: {},
  methods: {
    scrollToUpperMost() {
      utils.scrollToUpperMost();
    },

    checkDisabledStep2() {
      let selectedDataList =
        store.getSelectedDataListLocalStorageByCurrentUsername();

      if (selectedDataList == null || selectedDataList[0].items.length < 1) {
        this.disabledStep2 = true;
      } else {
        this.disabledStep2 = false;
      }
    },

    setIsStep2(val) {
      this.isStep2 = val;
    },

    setIsProcessingNow(val) {
      this.isProcessingNow = val;
    },

    setDisabledStep1(val) {
      this.disabledStep1 = val;
    },

    updateRefreshKeySelectedDataList(val) {
      this.refreshKeySelectedDataList = val;
    },

    updateTempDataCart(val) {
      this.tempDataCart = val;
    },
  },
  components: {
    "tabel-dinamis-title": Title,
    "main-progress-stepper": MainProgressStepper,
    "selection-step": SelectionStep,
    "visualization-step": VisualizationStep,
  },
};
</script>

<!-- css section-->
<style lang="scss" scoped>
@import "src/assets/scss/_table-dinamis";
</style>

<!-- author: m.hanif.fahyuananto-->
<!-- version 3.0.0 -->
<!-- created on 18-04-2022 -->
